export default __webpack_public_path__ + "static/media/To am xanh.23d64d43.png";